import aave from '../../images/tokens/aave.svg';
import ada from '../../images/tokens/ada.svg';
import alpaca from '../../images/tokens/alpaca.png';
import angle from '../../images/tokens/angle.svg';
import ankr from '../../images/tokens/ankr.svg';
import ankrBNB from '../../images/tokens/ankrBNB.svg';
import arb from '../../images/tokens/arb.svg';
import asBnb from '../../images/tokens/asBnb.svg';
import babyDoge from '../../images/tokens/babyDoge.svg';
import bal from '../../images/tokens/bal.svg';
import bch from '../../images/tokens/bch.svg';
import beth from '../../images/tokens/beth.svg';
import bifi from '../../images/tokens/bifi.png';
import bnb from '../../images/tokens/bnb.svg';
import bnbx from '../../images/tokens/bnbx.png';
import bsw from '../../images/tokens/bsw.svg';
import btcb from '../../images/tokens/btcb.svg';
import btt from '../../images/tokens/btt.svg';
import busd from '../../images/tokens/busd.svg';
import cake from '../../images/tokens/cake.svg';
import carrot from '../../images/tokens/carrot.png';
import cbbtc from '../../images/tokens/cbbtc.svg';
import crv from '../../images/tokens/crv.png';
import crvUsd from '../../images/tokens/crvUsd.png';
import dai from '../../images/tokens/dai.svg';
import defaultToken from '../../images/tokens/defaultToken.png';
import doge from '../../images/tokens/doge.svg';
import dot from '../../images/tokens/dot.svg';
import eBtc from '../../images/tokens/eBtc.png';
import eigen from '../../images/tokens/eigen.svg';
import eth from '../../images/tokens/eth.svg';
import eura from '../../images/tokens/eura.svg';
import ezEth from '../../images/tokens/ezEth.png';
import fdusd from '../../images/tokens/fdusd.svg';
import fil from '../../images/tokens/fil.svg';
import floki from '../../images/tokens/floki.svg';
import frax from '../../images/tokens/frax.svg';
import gmBtcUsdc from '../../images/tokens/gmBtcUsdc.svg';
import gmWEthUsdc from '../../images/tokens/gmWEthUsdc.svg';
import lbtc from '../../images/tokens/lbtc.svg';
import link from '../../images/tokens/link.svg';
import lisUSD from '../../images/tokens/lisUSD.png';
import ltc from '../../images/tokens/ltc.svg';
import luna from '../../images/tokens/luna.svg';
import matic from '../../images/tokens/matic.svg';
import nft from '../../images/tokens/nft.png';
import nvdab from '../../images/tokens/nvdab.png';
import op from '../../images/tokens/op.svg';
import planet from '../../images/tokens/planet.svg';
import ptClisBNB from '../../images/tokens/ptClisBNB.svg';
import ptSUsdE from '../../images/tokens/ptSUsdE.svg';
import ptSolvBtc from '../../images/tokens/ptSolvBtc.svg';
import ptUsdE from '../../images/tokens/ptUsdE.svg';
import ptWeeth from '../../images/tokens/ptWeeth.png';
import pufEth from '../../images/tokens/pufEth.png';
import raca from '../../images/tokens/raca.png';
import rsEth from '../../images/tokens/rsEth.svg';
import sFrax from '../../images/tokens/sFrax.svg';
import sUsdE from '../../images/tokens/sUsdE.svg';
import sUsds from '../../images/tokens/sUsds.svg';
import sd from '../../images/tokens/sd.svg';
import sfrxEth from '../../images/tokens/sfrxEth.svg';
import skhyb from '../../images/tokens/skhyb.png';
import slisBNB from '../../images/tokens/slisBNB.png';
import slisBnbX from '../../images/tokens/slisBnbX.svg';
import sol from '../../images/tokens/sol.svg';
import solvBtc from '../../images/tokens/solvBtc.png';
import spcxb from '../../images/tokens/spcxb.png';
import stkBNB from '../../images/tokens/stkBNB.svg';
import sxp from '../../images/tokens/sxp.svg';
import tBtc from '../../images/tokens/tBtc.svg';
import the from '../../images/tokens/the.svg';
import trx from '../../images/tokens/trx.svg';
import tslab from '../../images/tokens/tslab.svg';
import tusd from '../../images/tokens/tusd.svg';
import twt from '../../images/tokens/twt.svg';
import u from '../../images/tokens/u.png';
import uni from '../../images/tokens/uni.svg';
import usd1 from '../../images/tokens/usd1.png';
import usdc from '../../images/tokens/usdc.svg';
import usdcNative from '../../images/tokens/usdcNative.svg';
import usdd from '../../images/tokens/usdd.svg';
import usde from '../../images/tokens/usde.svg';
import usdf from '../../images/tokens/usdf.png';
import usds from '../../images/tokens/usds.svg';
import usdt from '../../images/tokens/usdt.svg';
import usdt0 from '../../images/tokens/usdt0.svg';
import ust from '../../images/tokens/ust.svg';
import vai from '../../images/tokens/vai.svg';
import vrt from '../../images/tokens/vrt.svg';
import wSuperOEthB from '../../images/tokens/wSuperOEthB.svg';
import wUsdm from '../../images/tokens/wUsdm.png';
import wbeth from '../../images/tokens/wbeth.svg';
import wbnb from '../../images/tokens/wbnb.svg';
import wbtc from '../../images/tokens/wbtc.svg';
import weEth from '../../images/tokens/weEth.svg';
import weeths from '../../images/tokens/weeths.svg';
import weth from '../../images/tokens/weth.svg';
import win from '../../images/tokens/win.svg';
import woo from '../../images/tokens/woo.svg';
import wstEth from '../../images/tokens/wstEth.svg';
import xSolvBtc from '../../images/tokens/xSolvBtc.svg';
import xaum from '../../images/tokens/xaum.png';
import xrp from '../../images/tokens/xrp.svg';
import xvs from '../../images/tokens/xvs.svg';
import yvusdc from '../../images/tokens/yvusdc.svg';
import yvusds from '../../images/tokens/yvusds.svg';
import yvusdt from '../../images/tokens/yvusdt.svg';
import yvweth from '../../images/tokens/yvweth.svg';
import zk from '../../images/tokens/zk.svg';
import zkEth from '../../images/tokens/zkEth.svg';

export const iconSrcs = {
    aave: aave,
    ada: ada,
    alpaca: alpaca,
    angle: angle,
    ankr: ankr,
    ankrBNB: ankrBNB,
    arb: arb,
    asBnb: asBnb,
    babyDoge: babyDoge,
    bal: bal,
    bch: bch,
    beth: beth,
    bifi: bifi,
    bnb: bnb,
    bnbx: bnbx,
    bsw: bsw,
    btcb: btcb,
    btt: btt,
    busd: busd,
    cake: cake,
    carrot: carrot,
    cbbtc: cbbtc,
    crv: crv,
    crvUsd: crvUsd,
    dai: dai,
    defaultToken: defaultToken,
    doge: doge,
    dot: dot,
    eBtc: eBtc,
    eigen: eigen,
    eth: eth,
    eura: eura,
    ezEth: ezEth,
    fdusd: fdusd,
    fil: fil,
    floki: floki,
    frax: frax,
    gmBtcUsdc: gmBtcUsdc,
    gmWEthUsdc: gmWEthUsdc,
    lbtc: lbtc,
    link: link,
    lisUSD: lisUSD,
    ltc: ltc,
    luna: luna,
    matic: matic,
    nft: nft,
    nvdab: nvdab,
    op: op,
    planet: planet,
    ptClisBNB: ptClisBNB,
    ptSUsdE: ptSUsdE,
    ptSolvBtc: ptSolvBtc,
    ptUsdE: ptUsdE,
    ptWeeth: ptWeeth,
    pufEth: pufEth,
    raca: raca,
    rsEth: rsEth,
    sFrax: sFrax,
    sUsdE: sUsdE,
    sUsds: sUsds,
    sd: sd,
    sfrxEth: sfrxEth,
    skhyb: skhyb,
    slisBNB: slisBNB,
    slisBnbX: slisBnbX,
    sol: sol,
    solvBtc: solvBtc,
    spcxb: spcxb,
    stkBNB: stkBNB,
    sxp: sxp,
    tBtc: tBtc,
    the: the,
    trx: trx,
    tslab: tslab,
    tusd: tusd,
    twt: twt,
    u: u,
    uni: uni,
    usd1: usd1,
    usdc: usdc,
    usdcNative: usdcNative,
    usdd: usdd,
    usde: usde,
    usdf: usdf,
    usds: usds,
    usdt: usdt,
    usdt0: usdt0,
    ust: ust,
    vai: vai,
    vrt: vrt,
    wSuperOEthB: wSuperOEthB,
    wUsdm: wUsdm,
    wbeth: wbeth,
    wbnb: wbnb,
    wbtc: wbtc,
    weEth: weEth,
    weeths: weeths,
    weth: weth,
    win: win,
    woo: woo,
    wstEth: wstEth,
    xSolvBtc: xSolvBtc,
    xaum: xaum,
    xrp: xrp,
    xvs: xvs,
    yvusdc: yvusdc,
    yvusds: yvusds,
    yvusdt: yvusdt,
    yvweth: yvweth,
    zk: zk,
    zkEth: zkEth,
};
